import { render, staticRenderFns } from "./TusAsientosComponent.vue?vue&type=template&id=2287f9ea"
import script from "./TusAsientosComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./TusAsientosComponent.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports